import BaseDevice from '../base.js'
import Lcd from './lcd.js'
export default class DeviceImage extends BaseDevice {
   static render = (device, scale = 1) => {

      const MODS = this.getMods(device.width)
      if (MODS <= 0) return;
      return this.getDevice(device, scale, Lcd.render(device.width, MODS));
   }
}
